var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLayout)?_c('div',[_c('item-detail-link',{attrs:{"detailLayout":_vm.detailLayout,"itemData":_vm.itemData}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }